import { lazy, Suspense } from 'react';

import { cn } from '@/lib/utils';
import {
  TEXTURE_PRESETS,
  type TextureState,
  type WarpedTexturePreset,
} from './texture-presets';
import { useNearViewport } from './useNearViewport';

export type { WarpedTexturePreset } from './texture-presets';

const WarpedTextureCanvas = lazy(() =>
  import('./WarpedTextureCanvas').then((module) => ({
    default: module.WarpedTextureCanvas,
  }))
);

/** Keep the static surface visible while its optional WebGL renderer loads. */
export function WarpedTexture({
  preset,
  className,
}: {
  preset: WarpedTexturePreset;
  className?: string;
}) {
  const { ref, ready } = useNearViewport<HTMLDivElement>();

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn('absolute inset-0 h-full w-full', className)}
      style={{ background: TEXTURE_PRESETS[preset].background }}
    >
      {ready && (
        <Suspense fallback={null}>
          <WarpedTextureCanvas preset={preset} />
        </Suspense>
      )}
    </div>
  );
}

/** Procedural warped/dithered backdrop for a security-layer card. */
export function SecurityCardTexture({
  state,
  className,
}: {
  state: TextureState;
  className?: string;
}) {
  return <WarpedTexture preset={state} {...(className ? { className } : {})} />;
}
